<template>
  <grid-table-wrapper
    :columns="columns"
    ref="controller"
    class="border-right border-no-left border-bottom"
    style="overflow-y: auto; overflow-x: hidden;"
  >
    <grid-header-content
      :columns="columns"
      :class-method="supplyHeaderClass"
      @click-cell="handleClickCell"
    />
  </grid-table-wrapper>
</template>
<script>
import GridTableWrapper from "@/components/grid/TableWrapper";
import GridHeaderContent from "@/components/grid/HeaderContent";
export default {
  name: "grid-column-index",
  components: { GridHeaderContent, GridTableWrapper },
  props: {
    columns: {
      type: Array,
    },
    selectedPart: Function,
  },
  methods: {
    scrollTo({ left }) {
      const { controller } = this.$refs;
      if (controller && controller.$el.scrollTo) {
        const { scrollTop, scrollLeft } = controller;
        if (scrollLeft !== left) {
          controller.$el.scrollTo(left, scrollTop);
        }
      }
    },
    isSelectedPart(index) {
      const { selectedPart } = this;
      if (selectedPart) {
        return selectedPart({ column: { index } });
      }
      return false;
    },
    supplyHeaderClass({ column }) {
      const { left, right } = this.selectedRange || {};
      const { selected, index } = column;
      // const selectedPart = left && right && left <= index && right >= index;
      const selectedPart = this.isSelectedPart(index);
      const obj = {
        "selected-all": selected,
        selected: selectedPart && !selected,
      };
      return ["column-index", obj];
    },
    handleClickCell(params, event) {
      if (this.$listeners["click-cell"]) {
        const { column } = params;
        const { ctrlKey, shiftKey } = event;
        this.$emit("click-cell", { column, multi: ctrlKey, range: shiftKey });
      }
    },
  },
};
</script>
